import { object, string, array, date } from '@/_config/lib/yup';
import { ENUM_CLOUD_ACTIVATION_REQUEST_STATUS } from '@/_features/places/constants';
import {
  ENUM_STATUS_PRE_REGISTRATION,
  TRANSLATE_STATUS_PRE_REGISTRATION,
} from '../constants';

export const PRE_REGISTRATION_TAB_SEARCH_PARAM = 'tab';

export const PRE_REGISTRATION_TABS = {
  DELIVERYMEN: 'entregadores',
  PARTNERS: 'parceiros',
};

export type PreRegistrationTabId =
  (typeof PRE_REGISTRATION_TABS)[keyof typeof PRE_REGISTRATION_TABS];

export const PRE_REGISTRATION_TAB_IDS: PreRegistrationTabId[] = [
  PRE_REGISTRATION_TABS.DELIVERYMEN,
  PRE_REGISTRATION_TABS.PARTNERS,
];

export const PRE_REGISTRATION_TAB_ITEMS = [
  {
    id: PRE_REGISTRATION_TABS.DELIVERYMEN,
    label: 'Entregadores',
  },
  {
    id: PRE_REGISTRATION_TABS.PARTNERS,
    label: 'Parceiros',
  },
];

export function getPreRegistrationTabFromSearchParams(
  searchParams: URLSearchParams,
): PreRegistrationTabId {
  const tab = searchParams.get(PRE_REGISTRATION_TAB_SEARCH_PARAM);

  if (tab && PRE_REGISTRATION_TAB_IDS.includes(tab as PreRegistrationTabId)) {
    return tab as PreRegistrationTabId;
  }

  return PRE_REGISTRATION_TABS.DELIVERYMEN;
}

export const PARTNERS_LIST_MIN_NAME_LENGTH = 2;

export const PARTNERS_LIST_DEFAULT_STATUS_FILTERS = [
  ENUM_CLOUD_ACTIVATION_REQUEST_STATUS.PENDING,
  ENUM_CLOUD_ACTIVATION_REQUEST_STATUS.RESERVE_BASE,
];

export const PARTNERS_LIST_SCHEMA = object({
  name: string().when([], (schema, name) =>
    name.value ? schema.min(PARTNERS_LIST_MIN_NAME_LENGTH) : schema.optional(),
  ),
  city: string().optional(),
  statusCloudActivationRequest: string()
    .transform((_, originalValue) =>
      originalValue === '' || originalValue == null ? undefined : originalValue,
    )
    .oneOf(Object.values(ENUM_CLOUD_ACTIVATION_REQUEST_STATUS))
    .optional(),
});

export const PRE_REGISTRATION_LIST_SCHEMA = object({
  cityId: string().optional(),
  deliverymanName: string().optional(),
  sendPreRegistrationAt: date().optional(),
  preRegistrationFilters: array().of(string()).optional(),
  vehicleType: string().optional(),
});

export const SHOW_DOCS_VALIDATION = [
  ENUM_STATUS_PRE_REGISTRATION.NEW_REGISTER_PEDING_VALIDATION,
  ENUM_STATUS_PRE_REGISTRATION.REPROVED_NEW_DOCUMENTATION_PROVIDED,
];

export const OPTIONS_STATUS_PRE_REGISTRATION = [
  {
    key: ENUM_STATUS_PRE_REGISTRATION.NEW_REGISTER_PEDING_VALIDATION,
    text: TRANSLATE_STATUS_PRE_REGISTRATION.NEW_REGISTER_PEDING_VALIDATION,
    value: ENUM_STATUS_PRE_REGISTRATION.NEW_REGISTER_PEDING_VALIDATION,
  },
  {
    key: ENUM_STATUS_PRE_REGISTRATION.REPROVED_FOR_CHECK,
    text: TRANSLATE_STATUS_PRE_REGISTRATION.REPROVED_FOR_CHECK,
    value: ENUM_STATUS_PRE_REGISTRATION.REPROVED_FOR_CHECK,
  },
  {
    key: ENUM_STATUS_PRE_REGISTRATION.REPROVED_PEDING_RESEND_DOCUMENTATION,
    text: TRANSLATE_STATUS_PRE_REGISTRATION.REPROVED_PEDING_RESEND_DOCUMENTATION,
    value: ENUM_STATUS_PRE_REGISTRATION.REPROVED_PEDING_RESEND_DOCUMENTATION,
  },
  {
    key: ENUM_STATUS_PRE_REGISTRATION.REPROVED_NEW_DOCUMENTATION_PROVIDED,
    text: TRANSLATE_STATUS_PRE_REGISTRATION.REPROVED_NEW_DOCUMENTATION_PROVIDED,
    value: ENUM_STATUS_PRE_REGISTRATION.REPROVED_NEW_DOCUMENTATION_PROVIDED,
  },
];
